import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Popover, Button, notification } from 'antd';
import { PERMISSIONS } from '../../../utils/permissions';
import Message from '../../../components/message/Message';
import { contentMessage } from '../../../helpers/contentMessage';
import Pagination from '../../../components/pagination/Pagination';
import { formatTime, formatDate } from '../../../helpers/helpers';
import { Link } from 'react-router-dom';
import { SERVER_URL } from '../../../config/index';
import { useAuth } from '../../../context/useAuth';
import Axios from 'axios';

const Table = (props) => {
  const { user } = useAuth();
  const { token } = user;
  const navigate = useNavigate();

  const [data, setData] = useState(props?.data ? props?.data : []);


  const handleDelete = async (id) => {
    await Axios.delete(`${SERVER_URL}/delete-question/${id}`, { withCredentials: false, headers: { Authorization: `Bearer ${token}` } });

    notification.success({ message: 'Pitanje je obrisano.' });

    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  return (
    <>
      <table className="table">
        <thead className="thead">
          <tr>
            <th>Ime i prezime</th>
            <th>Email</th>
            <th>Pitanje</th>
            <th>Status</th>
            <th>Akcije</th>
          </tr>
        </thead>
        <tbody className="tbody">
          {data && data.length > 0 ? (
            data?.map((item, idx) => {
              return (
                <tr key={item._id} className={item.status === 'Ordered' ? 'status-ordered' : ''}>
                  <td>
                    <div className="d-flex gap-x-2 align-center">
                      <span></span>
                      <span>{item.personFullName}</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-x-2 align-center">
                      <span></span>
                      <span>{item.email}</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-x-2 align-center">
                      <span></span>
                      <span>{item.description}</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-x-2 align-center">
                      <span></span>
                      <span>{item.status}</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-x-2 align-center">
                      <Link to={`/${PERMISSIONS.dashboard}/${PERMISSIONS.grocery}/${PERMISSIONS.updateQuestion}/${item._id}`} className="link btn-actions link-details">
                        <span style={{ cursor: 'pointer' }} className="icon d-flex">
                          <img alt="EDIT" src="/assets/icons/edit-user.svg" style={{ display: 'block' }} />
                        </span>
                      </Link>
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleDelete(item._id);
                        }}
                        className="icon d-flex"
                      >
                        <img alt="DELETE" src="/assets/icons/delete.svg" style={{ display: 'block' }} />
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={20} style={{ backgroundColor: '#fff', height: '200px', border: '0' }}>
                <Message className="content-message">
                  <h2 style={{ color: '#666' }}>{contentMessage.dataNotFound}</h2>
                </Message>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default Table;
